function ProfileOverviewController($scope, navigationService, LoggedInUser, notificationService) {
  navigationService.navigateProfile('profile.overview');

  $scope.user = LoggedInUser;

  notificationService.initialized.then(() => {
    notificationService.getAll('user', $scope.user.username, 0)
      .then((data) => {
        $scope.notifications = data;
      });
  });
}

const arr = [
  '$scope',
  'navigationService',
  'LoggedInUser',
  'notificationService',
  ProfileOverviewController
];

module.exports = (ngModule) => {
  ngModule.controller('ProfileOverviewController', arr);
};
